/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import * as API from '../../http/api';
import { closelightbox } from '../../util/Functions';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, TextField } from '@mui/material';
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const PldRelevanteModal = (props) => {
	const [zPos, setZPos] = useState(45)
	const [disabled, setDisabled] = useState(false);
	const [form, setForm] = useState({
		customer_uuid: '',
		uuid: props.customerUuid,
	})

	useEffect(()  => {
	}, []);

	const dowloadXML = (xmltext,name,ext)=>{
		var filename = name+ext; var pom = document.createElement('a'); 
		var bb = new Blob([xmltext], {type: 'text/plain'}); pom.setAttribute('href', window.URL.createObjectURL(bb)); 
		pom.setAttribute('download', filename); pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':'); pom.draggable = true; 
		pom.classList.add('dragout'); 
		pom.click();
	}
	
	const realizar = async () => {
		props.changeLoader(true);
		setZPos(-1)
		setDisabled(true)
		let data = {
			"data": {
				"tipo_reporte": "relevante",
				"cliente":{
					"uuid": props.customerUuid
				}
			}
		}

		let request:any = await API.service('pld', data, props.pos, props.changeAlert, props.changeLoader, props.history);
		if (request.status != 200  || request.data.data.response === "BAD" ) {
			props.changeAlert(true, 'error', request.data.data.message);
			setDisabled(false)
			props.changeLoader(false);
			setZPos(45) 
			closelightbox();
		}else{
			props.changeAlert(true, 'success', "Operación realizada");
			let widget = request.data.data.widget[0];
			dowloadXML(widget.content.xml,"Relevantes",".ITFR")
			setDisabled(false)
			props.changeLoader(false);
			setZPos(45)
			closelightbox();
		} 
	}

	return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle>
					Relevante
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

				<DialogContent sx={{paddingTop: "inherit !important"}}>
					<FormControl variant="standard" fullWidth>
						<TextField
							label="UUID" value={form.uuid} size="small" fullWidth	/>
					</FormControl>
				</DialogContent>

				<DialogActions>
					<Button variant="contained" disabled={disabled} onClick={realizar.bind(this)}>Realizar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
	)
}
export default PldRelevanteModal;